<li class="products__item product">
  <div class="product__general">
    <div class="product__general_image">
      <img
        [src]="image()"
        loading="lazy"
        onerror="onerror=null;src='assets/images/image-placeholder.svg';"
        [alt]="name()"
      />
    </div>

    <div class="product__general_info">
      <h5 class="product__general_info_name" [innerHTML]="name()"></h5>

      @if (addOns().length > 0) {
        <div class="product__general_info_add-ons add-ons">
          <ul class="add-ons__list">
            @for (addOn of groupedAddOns() | keyvalue; track $index) {
              <li class="add-ons__list-item add-on">
                <span class="add-on__title" [innerHtml]="addOn.key"></span>

                <ul class="add-on__options">
                  @for (addOnValue of addOn.value; track $index) {
                    <li class="add-on__options-item option">
                      <span class="option__name" [innerHtml]="addOnValue.value"></span>
                      @if (addOnValue.price != 0) {
                        <span class="option__price">
                          +{{ addOnValue.price | formattedCurrency: 0 }}
                        </span>
                      }
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        </div>
      }

      <span class="product__general_info_price">
        {{ price() | formattedCurrency: cartMinorUnit() }}
      </span>
    </div>
  </div>

  <div class="product__quantity">
    <app-counter
      [removable]="true"
      [style]="CounterStyle.Primary"
      [min]="minQuantity()"
      [max]="maxQuantity()"
      [disabled]="isDisabled()"
      [(ngModel)]="quantity"
      (ngModelChange)="onUpdate($event)"
      (remove)="onRemove()"
    />
  </div>
</li>
